module.exports = __webpack_public_path__ + "img/icon_hamburger.4217dd0b.svg";